import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { PAGE_ROUTES } from '../../../constants';
import { SharedModule } from '../../../shared/modules/shared.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-forgot-password-message',
  imports: [SharedModule, TranslatePipe, MatProgressSpinnerModule],
  standalone: true,
  templateUrl: './forgot-password-message.component.html',
  styleUrl: './forgot-password-message.component.scss'
})
export class ForgotPasswordMessageComponent implements OnChanges {
  @Input() email = '';
  @Input() isLoading = false;
  @Output() handleTryAgain = new EventEmitter();

  protected mailToLink = `mailto:${this.email}`;
  protected countdown = 0;

  private countdownSub?: Subscription;

  constructor(private router: Router) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isLoading'] && !this.isLoading && changes['isLoading'].previousValue === true) {
      this._startCountdown(60);
    }
  }

  handleLogin = async () => {
    this.router.navigate([PAGE_ROUTES.HOME], { queryParams: { email: this.email } });
  };

  handleResendEmail = () => {
    if (this.countdown === 0) this.handleTryAgain.emit();
  };

  _startCountdown(seconds: number) {
    this.countdown = seconds;

    this.countdownSub?.unsubscribe();

    this.countdownSub = timer(0, 1000).subscribe((n) => {
      this.countdown = seconds - n;

      if (this.countdown <= 0) this.countdownSub?.unsubscribe();
    });
  }
}
